import { FC } from 'react'

import { NatureElement } from '../types'
import { WaterElementImage } from './water-element-image'

export const WaterElement: FC<NatureElement> = ({ size = 330, onClick, className }) => {
  return (
    <svg x="-25" height={size} width={size} viewBox="0 0 72 70" fill="none" onClick={onClick} className={className}>
      <g filter="url(#filter0_dd_54_934)">
        <rect
          width="62.0925"
          height="62"
          transform="matrix(-1 0 0 1 67.0432 0)"
          fill="url(#water-element)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_54_934"
          x="0.950684"
          y="0"
          width="70.0925"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_934" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_54_934" result="effect2_dropShadow_54_934" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_934" result="shape" />
        </filter>
        <pattern id="water-element" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use href="#image0_54_934" transform="matrix(0.000753012 0 0 0.000754135 0 -0.00564759)" />
        </pattern>
        <WaterElementImage />
      </defs>
    </svg>
  )
}
